import React from 'react';
import { observer } from 'mobx-react';
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import consoleStore from 'stores/Console/ConsoleStore';
import { checkLogin } from 'routes/Utils';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';


const ProductsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/products" */
    'routes/Ecommerce/ProductsRoute'
  )
));

const ProductTagsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/product-tags" */
    'routes/Ecommerce/ProductTagsRoute'
  )
));

const ProductGroupsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/product-groups" */
    'routes/Ecommerce/ProductGroupsRoute'
  )
));

const WebTrackingRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/web-tracking" */
    'routes/Ecommerce/WebTrackingRoute'
  )
));

const EditWebTrackingRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/edit-web-tracking" */
    'routes/Ecommerce/EditWebTrackingRoute'
  )
));

const WebTrackingManualInstallationRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/web-tracking-manual-installation" */
    'routes/Ecommerce/WebTrackingManualInstallationRoute'
  )
));

const ConversionSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/conversion-settings" */
    'routes/Ecommerce/ConversionSettingsRoute'
  )
));

const EditConversionSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/ecommerce/edit-conversion-settings" */
    'routes/Ecommerce/EditConversionSettingsRoute'
  )
));


const getEcommerceRoutes = () => {
  return [
    {path: paths.getPathProducts(), component: ProductsRoute},
    {path: paths.getPathProductTags(), component: ProductTagsRoute},
    {path: paths.getPathProductGroups(), component: ProductGroupsRoute},

    {path: paths.getPathWebTracking(), component: WebTrackingRoute},
    {path: paths.getPathEditWebTracking(), component: EditWebTrackingRoute},
    {path: paths.getPathWebTrackingManualInstallation(), component: WebTrackingManualInstallationRoute},

    {path: paths.getPathConversionSettings(), component: ConversionSettingsRoute},
    {path: paths.getPathEditConversionSettings(), component: EditConversionSettingsRoute},
  ]
}



export { getEcommerceRoutes };
